import { defineComponent as o, h as t } from "vue";
import { radioBaseProps as i, setup as r } from "./ghl-ui.es1043.js";
import { resolveWrappedSlot as s } from "./ghl-ui.es826.js";
const u = o({
  name: "RadioButton",
  props: i,
  setup: r,
  render() {
    const {
      mergedClsPrefix: e
    } = this;
    return t("label", {
      class: [`${e}-radio-button`, this.mergedDisabled && `${e}-radio-button--disabled`, this.renderSafeChecked && `${e}-radio-button--checked`, this.focus && [`${e}-radio-button--focus`]]
    }, t("input", {
      ref: "inputRef",
      type: "radio",
      class: `${e}-radio-input`,
      value: this.value,
      name: this.mergedName,
      checked: this.renderSafeChecked,
      disabled: this.mergedDisabled,
      onChange: this.handleRadioInputChange,
      onFocus: this.handleRadioInputFocus,
      onBlur: this.handleRadioInputBlur
    }), t("div", {
      class: `${e}-radio-button__state-border`
    }), s(this.$slots.default, (a) => !a && !this.label ? null : t("div", {
      ref: "labelRef",
      class: `${e}-radio__label`
    }, a || this.label)));
  }
});
export {
  u as default
};
